/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as RegisterImport } from './routes/register'
import { Route as PostalRequestCodeImport } from './routes/postal-request-code'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as InactivityLogoutImport } from './routes/inactivity-logout'
import { Route as GeoBlockImport } from './routes/geo-block'
import { Route as TakeABreakConfirmationRouteImport } from './routes/take-a-break-confirmation/route'
import { Route as SelfExclusionConfirmationRouteImport } from './routes/self-exclusion-confirmation/route'
import { Route as AuthServerUnavailableRouteImport } from './routes/auth-server-unavailable/route'
import { Route as AppRouteImport } from './routes/_app/route'
import { Route as AppStoreRouteImport } from './routes/_app/store/route'
import { Route as AppSearchRouteImport } from './routes/_app/search/route'
import { Route as AppRedemptionHistoryRouteImport } from './routes/_app/redemption-history/route'
import { Route as AppRedeemRouteImport } from './routes/_app/redeem/route'
import { Route as AppQuestsRouteImport } from './routes/_app/quests/route'
import { Route as AppPurchaseHistoryRouteImport } from './routes/_app/purchase-history/route'
import { Route as AppInboxRouteImport } from './routes/_app/inbox/route'
import { Route as AppActivityLogRouteImport } from './routes/_app/activity-log/route'
import { Route as AppAccountVerificationRouteImport } from './routes/_app/account-verification/route'
import { Route as AppAccountLockedRouteImport } from './routes/_app/account-locked/route'
import { Route as AppIndexRouteImport } from './routes/_app/index/route'
import { Route as AppStorePlayForFreeImport } from './routes/_app/store/play-for-free'
import { Route as AppStoreBuyGoldCoinsImport } from './routes/_app/store/buy-gold-coins'
import { Route as AppQuestsQuestsHistoryImport } from './routes/_app/quests/quests-history'
import { Route as AppQuestsActiveQuestsImport } from './routes/_app/quests/active-quests'
import { Route as AppAccountVerificationTncImport } from './routes/_app/account-verification_/tnc'
import { Route as AppAccountVerificationFlowImport } from './routes/_app/account-verification_/flow'
import { Route as AppAccountLockedVerificationRequiredImport } from './routes/_app/account-locked/verification-required'
import { Route as AppAccountLockedUnderAgeImport } from './routes/_app/account-locked/under-age'
import { Route as AppAccountLockedTakeABreakImport } from './routes/_app/account-locked/take-a-break'
import { Route as AppAccountLockedSelfExclusionImport } from './routes/_app/account-locked/self-exclusion'
import { Route as AppAccountLockedRestrictedJurisdictionImport } from './routes/_app/account-locked/restricted-jurisdiction'
import { Route as AppAccountLockedErrorImport } from './routes/_app/account-locked/error'
import { Route as AppYourPlayGameplayLimitsRouteImport } from './routes/_app/your-play.gameplay-limits/route'
import { Route as AppYourPlayGameplayHistoryRouteImport } from './routes/_app/your-play.gameplay-history/route'
import { Route as AppYourPlayActivityReminderRouteImport } from './routes/_app/your-play.activity-reminder/route'
import { Route as AppYourPlayAccessControlsRouteImport } from './routes/_app/your-play.access-controls/route'
import { Route as AppGamePlayGameIdRouteImport } from './routes/_app/game-play.$gameId/route'
import { Route as AppCategoryIdRouteImport } from './routes/_app/category.$id/route'
import { Route as AppStoreBuyGoldCoinsIdImport } from './routes/_app/store/buy-gold-coins.$id'
import { Route as AppYourPlayGameplayLimitsAllRouteImport } from './routes/_app/your-play.gameplay-limits/all/route'
import { Route as AppYourPlayGameplayLimitsAddRouteImport } from './routes/_app/your-play.gameplay-limits/add/route'
import { Route as AppYourPlayActivityReminderSetReminderRouteImport } from './routes/_app/your-play.activity-reminder/set-reminder/route'
import { Route as AppYourPlayAccessControlsTakeABreakRouteImport } from './routes/_app/your-play.access-controls/take-a-break/route'
import { Route as AppYourPlayAccessControlsSelfExclusionRouteImport } from './routes/_app/your-play.access-controls/self-exclusion/route'
import { Route as AppYourPlayAccessControlsAllRouteImport } from './routes/_app/your-play.access-controls/all/route'
import { Route as AppYourPlayActivityReminderIndexRouteImport } from './routes/_app/your-play.activity-reminder/index/route'
import { Route as AppYourPlayGameplayLimitsManageTypeRouteImport } from './routes/_app/your-play.gameplay-limits/manage.$type/route'

// Create/Update Routes

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const PostalRequestCodeRoute = PostalRequestCodeImport.update({
  id: '/postal-request-code',
  path: '/postal-request-code',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const InactivityLogoutRoute = InactivityLogoutImport.update({
  id: '/inactivity-logout',
  path: '/inactivity-logout',
  getParentRoute: () => rootRoute,
} as any)

const GeoBlockRoute = GeoBlockImport.update({
  id: '/geo-block',
  path: '/geo-block',
  getParentRoute: () => rootRoute,
} as any)

const TakeABreakConfirmationRouteRoute =
  TakeABreakConfirmationRouteImport.update({
    id: '/take-a-break-confirmation',
    path: '/take-a-break-confirmation',
    getParentRoute: () => rootRoute,
  } as any)

const SelfExclusionConfirmationRouteRoute =
  SelfExclusionConfirmationRouteImport.update({
    id: '/self-exclusion-confirmation',
    path: '/self-exclusion-confirmation',
    getParentRoute: () => rootRoute,
  } as any)

const AuthServerUnavailableRouteRoute = AuthServerUnavailableRouteImport.update(
  {
    id: '/auth-server-unavailable',
    path: '/auth-server-unavailable',
    getParentRoute: () => rootRoute,
  } as any,
)

const AppRouteRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppStoreRouteRoute = AppStoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppSearchRouteRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppRedemptionHistoryRouteRoute = AppRedemptionHistoryRouteImport.update({
  id: '/redemption-history',
  path: '/redemption-history',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppRedeemRouteRoute = AppRedeemRouteImport.update({
  id: '/redeem',
  path: '/redeem',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppQuestsRouteRoute = AppQuestsRouteImport.update({
  id: '/quests',
  path: '/quests',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppPurchaseHistoryRouteRoute = AppPurchaseHistoryRouteImport.update({
  id: '/purchase-history',
  path: '/purchase-history',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInboxRouteRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppActivityLogRouteRoute = AppActivityLogRouteImport.update({
  id: '/activity-log',
  path: '/activity-log',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAccountVerificationRouteRoute =
  AppAccountVerificationRouteImport.update({
    id: '/account-verification',
    path: '/account-verification',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppAccountLockedRouteRoute = AppAccountLockedRouteImport.update({
  id: '/account-locked',
  path: '/account-locked',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppIndexRouteRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppStorePlayForFreeRoute = AppStorePlayForFreeImport.update({
  id: '/play-for-free',
  path: '/play-for-free',
  getParentRoute: () => AppStoreRouteRoute,
} as any)

const AppStoreBuyGoldCoinsRoute = AppStoreBuyGoldCoinsImport.update({
  id: '/buy-gold-coins',
  path: '/buy-gold-coins',
  getParentRoute: () => AppStoreRouteRoute,
} as any)

const AppQuestsQuestsHistoryRoute = AppQuestsQuestsHistoryImport.update({
  id: '/quests-history',
  path: '/quests-history',
  getParentRoute: () => AppQuestsRouteRoute,
} as any)

const AppQuestsActiveQuestsRoute = AppQuestsActiveQuestsImport.update({
  id: '/active-quests',
  path: '/active-quests',
  getParentRoute: () => AppQuestsRouteRoute,
} as any)

const AppAccountVerificationTncRoute = AppAccountVerificationTncImport.update({
  id: '/account-verification_/tnc',
  path: '/account-verification/tnc',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAccountVerificationFlowRoute = AppAccountVerificationFlowImport.update(
  {
    id: '/account-verification_/flow',
    path: '/account-verification/flow',
    getParentRoute: () => AppRouteRoute,
  } as any,
)

const AppAccountLockedVerificationRequiredRoute =
  AppAccountLockedVerificationRequiredImport.update({
    id: '/verification-required',
    path: '/verification-required',
    getParentRoute: () => AppAccountLockedRouteRoute,
  } as any)

const AppAccountLockedUnderAgeRoute = AppAccountLockedUnderAgeImport.update({
  id: '/under-age',
  path: '/under-age',
  getParentRoute: () => AppAccountLockedRouteRoute,
} as any)

const AppAccountLockedTakeABreakRoute = AppAccountLockedTakeABreakImport.update(
  {
    id: '/take-a-break',
    path: '/take-a-break',
    getParentRoute: () => AppAccountLockedRouteRoute,
  } as any,
)

const AppAccountLockedSelfExclusionRoute =
  AppAccountLockedSelfExclusionImport.update({
    id: '/self-exclusion',
    path: '/self-exclusion',
    getParentRoute: () => AppAccountLockedRouteRoute,
  } as any)

const AppAccountLockedRestrictedJurisdictionRoute =
  AppAccountLockedRestrictedJurisdictionImport.update({
    id: '/restricted-jurisdiction',
    path: '/restricted-jurisdiction',
    getParentRoute: () => AppAccountLockedRouteRoute,
  } as any)

const AppAccountLockedErrorRoute = AppAccountLockedErrorImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AppAccountLockedRouteRoute,
} as any)

const AppYourPlayGameplayLimitsRouteRoute =
  AppYourPlayGameplayLimitsRouteImport.update({
    id: '/your-play/gameplay-limits',
    path: '/your-play/gameplay-limits',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppYourPlayGameplayHistoryRouteRoute =
  AppYourPlayGameplayHistoryRouteImport.update({
    id: '/your-play/gameplay-history',
    path: '/your-play/gameplay-history',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppYourPlayActivityReminderRouteRoute =
  AppYourPlayActivityReminderRouteImport.update({
    id: '/your-play/activity-reminder',
    path: '/your-play/activity-reminder',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppYourPlayAccessControlsRouteRoute =
  AppYourPlayAccessControlsRouteImport.update({
    id: '/your-play/access-controls',
    path: '/your-play/access-controls',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppGamePlayGameIdRouteRoute = AppGamePlayGameIdRouteImport.update({
  id: '/game-play/$gameId',
  path: '/game-play/$gameId',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCategoryIdRouteRoute = AppCategoryIdRouteImport.update({
  id: '/category/$id',
  path: '/category/$id',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppStoreBuyGoldCoinsIdRoute = AppStoreBuyGoldCoinsIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppStoreBuyGoldCoinsRoute,
} as any)

const AppYourPlayGameplayLimitsAllRouteRoute =
  AppYourPlayGameplayLimitsAllRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AppYourPlayGameplayLimitsRouteRoute,
  } as any)

const AppYourPlayGameplayLimitsAddRouteRoute =
  AppYourPlayGameplayLimitsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AppYourPlayGameplayLimitsRouteRoute,
  } as any)

const AppYourPlayActivityReminderSetReminderRouteRoute =
  AppYourPlayActivityReminderSetReminderRouteImport.update({
    id: '/set-reminder',
    path: '/set-reminder',
    getParentRoute: () => AppYourPlayActivityReminderRouteRoute,
  } as any)

const AppYourPlayAccessControlsTakeABreakRouteRoute =
  AppYourPlayAccessControlsTakeABreakRouteImport.update({
    id: '/take-a-break',
    path: '/take-a-break',
    getParentRoute: () => AppYourPlayAccessControlsRouteRoute,
  } as any)

const AppYourPlayAccessControlsSelfExclusionRouteRoute =
  AppYourPlayAccessControlsSelfExclusionRouteImport.update({
    id: '/self-exclusion',
    path: '/self-exclusion',
    getParentRoute: () => AppYourPlayAccessControlsRouteRoute,
  } as any)

const AppYourPlayAccessControlsAllRouteRoute =
  AppYourPlayAccessControlsAllRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AppYourPlayAccessControlsRouteRoute,
  } as any)

const AppYourPlayActivityReminderIndexRouteRoute =
  AppYourPlayActivityReminderIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppYourPlayActivityReminderRouteRoute,
  } as any)

const AppYourPlayGameplayLimitsManageTypeRouteRoute =
  AppYourPlayGameplayLimitsManageTypeRouteImport.update({
    id: '/manage/$type',
    path: '/manage/$type',
    getParentRoute: () => AppYourPlayGameplayLimitsRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/auth-server-unavailable': {
      id: '/auth-server-unavailable'
      path: '/auth-server-unavailable'
      fullPath: '/auth-server-unavailable'
      preLoaderRoute: typeof AuthServerUnavailableRouteImport
      parentRoute: typeof rootRoute
    }
    '/self-exclusion-confirmation': {
      id: '/self-exclusion-confirmation'
      path: '/self-exclusion-confirmation'
      fullPath: '/self-exclusion-confirmation'
      preLoaderRoute: typeof SelfExclusionConfirmationRouteImport
      parentRoute: typeof rootRoute
    }
    '/take-a-break-confirmation': {
      id: '/take-a-break-confirmation'
      path: '/take-a-break-confirmation'
      fullPath: '/take-a-break-confirmation'
      preLoaderRoute: typeof TakeABreakConfirmationRouteImport
      parentRoute: typeof rootRoute
    }
    '/geo-block': {
      id: '/geo-block'
      path: '/geo-block'
      fullPath: '/geo-block'
      preLoaderRoute: typeof GeoBlockImport
      parentRoute: typeof rootRoute
    }
    '/inactivity-logout': {
      id: '/inactivity-logout'
      path: '/inactivity-logout'
      fullPath: '/inactivity-logout'
      preLoaderRoute: typeof InactivityLogoutImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/postal-request-code': {
      id: '/postal-request-code'
      path: '/postal-request-code'
      fullPath: '/postal-request-code'
      preLoaderRoute: typeof PostalRequestCodeImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/account-locked': {
      id: '/_app/account-locked'
      path: '/account-locked'
      fullPath: '/account-locked'
      preLoaderRoute: typeof AppAccountLockedRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/account-verification': {
      id: '/_app/account-verification'
      path: '/account-verification'
      fullPath: '/account-verification'
      preLoaderRoute: typeof AppAccountVerificationRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/activity-log': {
      id: '/_app/activity-log'
      path: '/activity-log'
      fullPath: '/activity-log'
      preLoaderRoute: typeof AppActivityLogRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/purchase-history': {
      id: '/_app/purchase-history'
      path: '/purchase-history'
      fullPath: '/purchase-history'
      preLoaderRoute: typeof AppPurchaseHistoryRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/quests': {
      id: '/_app/quests'
      path: '/quests'
      fullPath: '/quests'
      preLoaderRoute: typeof AppQuestsRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/redeem': {
      id: '/_app/redeem'
      path: '/redeem'
      fullPath: '/redeem'
      preLoaderRoute: typeof AppRedeemRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/redemption-history': {
      id: '/_app/redemption-history'
      path: '/redemption-history'
      fullPath: '/redemption-history'
      preLoaderRoute: typeof AppRedemptionHistoryRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/store': {
      id: '/_app/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof AppStoreRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/category/$id': {
      id: '/_app/category/$id'
      path: '/category/$id'
      fullPath: '/category/$id'
      preLoaderRoute: typeof AppCategoryIdRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/game-play/$gameId': {
      id: '/_app/game-play/$gameId'
      path: '/game-play/$gameId'
      fullPath: '/game-play/$gameId'
      preLoaderRoute: typeof AppGamePlayGameIdRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/your-play/access-controls': {
      id: '/_app/your-play/access-controls'
      path: '/your-play/access-controls'
      fullPath: '/your-play/access-controls'
      preLoaderRoute: typeof AppYourPlayAccessControlsRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/your-play/activity-reminder': {
      id: '/_app/your-play/activity-reminder'
      path: '/your-play/activity-reminder'
      fullPath: '/your-play/activity-reminder'
      preLoaderRoute: typeof AppYourPlayActivityReminderRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/your-play/gameplay-history': {
      id: '/_app/your-play/gameplay-history'
      path: '/your-play/gameplay-history'
      fullPath: '/your-play/gameplay-history'
      preLoaderRoute: typeof AppYourPlayGameplayHistoryRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/your-play/gameplay-limits': {
      id: '/_app/your-play/gameplay-limits'
      path: '/your-play/gameplay-limits'
      fullPath: '/your-play/gameplay-limits'
      preLoaderRoute: typeof AppYourPlayGameplayLimitsRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/account-locked/error': {
      id: '/_app/account-locked/error'
      path: '/error'
      fullPath: '/account-locked/error'
      preLoaderRoute: typeof AppAccountLockedErrorImport
      parentRoute: typeof AppAccountLockedRouteImport
    }
    '/_app/account-locked/restricted-jurisdiction': {
      id: '/_app/account-locked/restricted-jurisdiction'
      path: '/restricted-jurisdiction'
      fullPath: '/account-locked/restricted-jurisdiction'
      preLoaderRoute: typeof AppAccountLockedRestrictedJurisdictionImport
      parentRoute: typeof AppAccountLockedRouteImport
    }
    '/_app/account-locked/self-exclusion': {
      id: '/_app/account-locked/self-exclusion'
      path: '/self-exclusion'
      fullPath: '/account-locked/self-exclusion'
      preLoaderRoute: typeof AppAccountLockedSelfExclusionImport
      parentRoute: typeof AppAccountLockedRouteImport
    }
    '/_app/account-locked/take-a-break': {
      id: '/_app/account-locked/take-a-break'
      path: '/take-a-break'
      fullPath: '/account-locked/take-a-break'
      preLoaderRoute: typeof AppAccountLockedTakeABreakImport
      parentRoute: typeof AppAccountLockedRouteImport
    }
    '/_app/account-locked/under-age': {
      id: '/_app/account-locked/under-age'
      path: '/under-age'
      fullPath: '/account-locked/under-age'
      preLoaderRoute: typeof AppAccountLockedUnderAgeImport
      parentRoute: typeof AppAccountLockedRouteImport
    }
    '/_app/account-locked/verification-required': {
      id: '/_app/account-locked/verification-required'
      path: '/verification-required'
      fullPath: '/account-locked/verification-required'
      preLoaderRoute: typeof AppAccountLockedVerificationRequiredImport
      parentRoute: typeof AppAccountLockedRouteImport
    }
    '/_app/account-verification_/flow': {
      id: '/_app/account-verification_/flow'
      path: '/account-verification/flow'
      fullPath: '/account-verification/flow'
      preLoaderRoute: typeof AppAccountVerificationFlowImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/account-verification_/tnc': {
      id: '/_app/account-verification_/tnc'
      path: '/account-verification/tnc'
      fullPath: '/account-verification/tnc'
      preLoaderRoute: typeof AppAccountVerificationTncImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/quests/active-quests': {
      id: '/_app/quests/active-quests'
      path: '/active-quests'
      fullPath: '/quests/active-quests'
      preLoaderRoute: typeof AppQuestsActiveQuestsImport
      parentRoute: typeof AppQuestsRouteImport
    }
    '/_app/quests/quests-history': {
      id: '/_app/quests/quests-history'
      path: '/quests-history'
      fullPath: '/quests/quests-history'
      preLoaderRoute: typeof AppQuestsQuestsHistoryImport
      parentRoute: typeof AppQuestsRouteImport
    }
    '/_app/store/buy-gold-coins': {
      id: '/_app/store/buy-gold-coins'
      path: '/buy-gold-coins'
      fullPath: '/store/buy-gold-coins'
      preLoaderRoute: typeof AppStoreBuyGoldCoinsImport
      parentRoute: typeof AppStoreRouteImport
    }
    '/_app/store/play-for-free': {
      id: '/_app/store/play-for-free'
      path: '/play-for-free'
      fullPath: '/store/play-for-free'
      preLoaderRoute: typeof AppStorePlayForFreeImport
      parentRoute: typeof AppStoreRouteImport
    }
    '/_app/your-play/activity-reminder/': {
      id: '/_app/your-play/activity-reminder/'
      path: '/'
      fullPath: '/your-play/activity-reminder/'
      preLoaderRoute: typeof AppYourPlayActivityReminderIndexRouteImport
      parentRoute: typeof AppYourPlayActivityReminderRouteImport
    }
    '/_app/your-play/access-controls/all': {
      id: '/_app/your-play/access-controls/all'
      path: '/all'
      fullPath: '/your-play/access-controls/all'
      preLoaderRoute: typeof AppYourPlayAccessControlsAllRouteImport
      parentRoute: typeof AppYourPlayAccessControlsRouteImport
    }
    '/_app/your-play/access-controls/self-exclusion': {
      id: '/_app/your-play/access-controls/self-exclusion'
      path: '/self-exclusion'
      fullPath: '/your-play/access-controls/self-exclusion'
      preLoaderRoute: typeof AppYourPlayAccessControlsSelfExclusionRouteImport
      parentRoute: typeof AppYourPlayAccessControlsRouteImport
    }
    '/_app/your-play/access-controls/take-a-break': {
      id: '/_app/your-play/access-controls/take-a-break'
      path: '/take-a-break'
      fullPath: '/your-play/access-controls/take-a-break'
      preLoaderRoute: typeof AppYourPlayAccessControlsTakeABreakRouteImport
      parentRoute: typeof AppYourPlayAccessControlsRouteImport
    }
    '/_app/your-play/activity-reminder/set-reminder': {
      id: '/_app/your-play/activity-reminder/set-reminder'
      path: '/set-reminder'
      fullPath: '/your-play/activity-reminder/set-reminder'
      preLoaderRoute: typeof AppYourPlayActivityReminderSetReminderRouteImport
      parentRoute: typeof AppYourPlayActivityReminderRouteImport
    }
    '/_app/your-play/gameplay-limits/add': {
      id: '/_app/your-play/gameplay-limits/add'
      path: '/add'
      fullPath: '/your-play/gameplay-limits/add'
      preLoaderRoute: typeof AppYourPlayGameplayLimitsAddRouteImport
      parentRoute: typeof AppYourPlayGameplayLimitsRouteImport
    }
    '/_app/your-play/gameplay-limits/all': {
      id: '/_app/your-play/gameplay-limits/all'
      path: '/all'
      fullPath: '/your-play/gameplay-limits/all'
      preLoaderRoute: typeof AppYourPlayGameplayLimitsAllRouteImport
      parentRoute: typeof AppYourPlayGameplayLimitsRouteImport
    }
    '/_app/store/buy-gold-coins/$id': {
      id: '/_app/store/buy-gold-coins/$id'
      path: '/$id'
      fullPath: '/store/buy-gold-coins/$id'
      preLoaderRoute: typeof AppStoreBuyGoldCoinsIdImport
      parentRoute: typeof AppStoreBuyGoldCoinsImport
    }
    '/_app/your-play/gameplay-limits/manage/$type': {
      id: '/_app/your-play/gameplay-limits/manage/$type'
      path: '/manage/$type'
      fullPath: '/your-play/gameplay-limits/manage/$type'
      preLoaderRoute: typeof AppYourPlayGameplayLimitsManageTypeRouteImport
      parentRoute: typeof AppYourPlayGameplayLimitsRouteImport
    }
  }
}

// Create and export the route tree

interface AppAccountLockedRouteRouteChildren {
  AppAccountLockedErrorRoute: typeof AppAccountLockedErrorRoute
  AppAccountLockedRestrictedJurisdictionRoute: typeof AppAccountLockedRestrictedJurisdictionRoute
  AppAccountLockedSelfExclusionRoute: typeof AppAccountLockedSelfExclusionRoute
  AppAccountLockedTakeABreakRoute: typeof AppAccountLockedTakeABreakRoute
  AppAccountLockedUnderAgeRoute: typeof AppAccountLockedUnderAgeRoute
  AppAccountLockedVerificationRequiredRoute: typeof AppAccountLockedVerificationRequiredRoute
}

const AppAccountLockedRouteRouteChildren: AppAccountLockedRouteRouteChildren = {
  AppAccountLockedErrorRoute: AppAccountLockedErrorRoute,
  AppAccountLockedRestrictedJurisdictionRoute:
    AppAccountLockedRestrictedJurisdictionRoute,
  AppAccountLockedSelfExclusionRoute: AppAccountLockedSelfExclusionRoute,
  AppAccountLockedTakeABreakRoute: AppAccountLockedTakeABreakRoute,
  AppAccountLockedUnderAgeRoute: AppAccountLockedUnderAgeRoute,
  AppAccountLockedVerificationRequiredRoute:
    AppAccountLockedVerificationRequiredRoute,
}

const AppAccountLockedRouteRouteWithChildren =
  AppAccountLockedRouteRoute._addFileChildren(
    AppAccountLockedRouteRouteChildren,
  )

interface AppQuestsRouteRouteChildren {
  AppQuestsActiveQuestsRoute: typeof AppQuestsActiveQuestsRoute
  AppQuestsQuestsHistoryRoute: typeof AppQuestsQuestsHistoryRoute
}

const AppQuestsRouteRouteChildren: AppQuestsRouteRouteChildren = {
  AppQuestsActiveQuestsRoute: AppQuestsActiveQuestsRoute,
  AppQuestsQuestsHistoryRoute: AppQuestsQuestsHistoryRoute,
}

const AppQuestsRouteRouteWithChildren = AppQuestsRouteRoute._addFileChildren(
  AppQuestsRouteRouteChildren,
)

interface AppStoreBuyGoldCoinsRouteChildren {
  AppStoreBuyGoldCoinsIdRoute: typeof AppStoreBuyGoldCoinsIdRoute
}

const AppStoreBuyGoldCoinsRouteChildren: AppStoreBuyGoldCoinsRouteChildren = {
  AppStoreBuyGoldCoinsIdRoute: AppStoreBuyGoldCoinsIdRoute,
}

const AppStoreBuyGoldCoinsRouteWithChildren =
  AppStoreBuyGoldCoinsRoute._addFileChildren(AppStoreBuyGoldCoinsRouteChildren)

interface AppStoreRouteRouteChildren {
  AppStoreBuyGoldCoinsRoute: typeof AppStoreBuyGoldCoinsRouteWithChildren
  AppStorePlayForFreeRoute: typeof AppStorePlayForFreeRoute
}

const AppStoreRouteRouteChildren: AppStoreRouteRouteChildren = {
  AppStoreBuyGoldCoinsRoute: AppStoreBuyGoldCoinsRouteWithChildren,
  AppStorePlayForFreeRoute: AppStorePlayForFreeRoute,
}

const AppStoreRouteRouteWithChildren = AppStoreRouteRoute._addFileChildren(
  AppStoreRouteRouteChildren,
)

interface AppYourPlayAccessControlsRouteRouteChildren {
  AppYourPlayAccessControlsAllRouteRoute: typeof AppYourPlayAccessControlsAllRouteRoute
  AppYourPlayAccessControlsSelfExclusionRouteRoute: typeof AppYourPlayAccessControlsSelfExclusionRouteRoute
  AppYourPlayAccessControlsTakeABreakRouteRoute: typeof AppYourPlayAccessControlsTakeABreakRouteRoute
}

const AppYourPlayAccessControlsRouteRouteChildren: AppYourPlayAccessControlsRouteRouteChildren =
  {
    AppYourPlayAccessControlsAllRouteRoute:
      AppYourPlayAccessControlsAllRouteRoute,
    AppYourPlayAccessControlsSelfExclusionRouteRoute:
      AppYourPlayAccessControlsSelfExclusionRouteRoute,
    AppYourPlayAccessControlsTakeABreakRouteRoute:
      AppYourPlayAccessControlsTakeABreakRouteRoute,
  }

const AppYourPlayAccessControlsRouteRouteWithChildren =
  AppYourPlayAccessControlsRouteRoute._addFileChildren(
    AppYourPlayAccessControlsRouteRouteChildren,
  )

interface AppYourPlayActivityReminderRouteRouteChildren {
  AppYourPlayActivityReminderIndexRouteRoute: typeof AppYourPlayActivityReminderIndexRouteRoute
  AppYourPlayActivityReminderSetReminderRouteRoute: typeof AppYourPlayActivityReminderSetReminderRouteRoute
}

const AppYourPlayActivityReminderRouteRouteChildren: AppYourPlayActivityReminderRouteRouteChildren =
  {
    AppYourPlayActivityReminderIndexRouteRoute:
      AppYourPlayActivityReminderIndexRouteRoute,
    AppYourPlayActivityReminderSetReminderRouteRoute:
      AppYourPlayActivityReminderSetReminderRouteRoute,
  }

const AppYourPlayActivityReminderRouteRouteWithChildren =
  AppYourPlayActivityReminderRouteRoute._addFileChildren(
    AppYourPlayActivityReminderRouteRouteChildren,
  )

interface AppYourPlayGameplayLimitsRouteRouteChildren {
  AppYourPlayGameplayLimitsAddRouteRoute: typeof AppYourPlayGameplayLimitsAddRouteRoute
  AppYourPlayGameplayLimitsAllRouteRoute: typeof AppYourPlayGameplayLimitsAllRouteRoute
  AppYourPlayGameplayLimitsManageTypeRouteRoute: typeof AppYourPlayGameplayLimitsManageTypeRouteRoute
}

const AppYourPlayGameplayLimitsRouteRouteChildren: AppYourPlayGameplayLimitsRouteRouteChildren =
  {
    AppYourPlayGameplayLimitsAddRouteRoute:
      AppYourPlayGameplayLimitsAddRouteRoute,
    AppYourPlayGameplayLimitsAllRouteRoute:
      AppYourPlayGameplayLimitsAllRouteRoute,
    AppYourPlayGameplayLimitsManageTypeRouteRoute:
      AppYourPlayGameplayLimitsManageTypeRouteRoute,
  }

const AppYourPlayGameplayLimitsRouteRouteWithChildren =
  AppYourPlayGameplayLimitsRouteRoute._addFileChildren(
    AppYourPlayGameplayLimitsRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppIndexRouteRoute: typeof AppIndexRouteRoute
  AppAccountLockedRouteRoute: typeof AppAccountLockedRouteRouteWithChildren
  AppAccountVerificationRouteRoute: typeof AppAccountVerificationRouteRoute
  AppActivityLogRouteRoute: typeof AppActivityLogRouteRoute
  AppInboxRouteRoute: typeof AppInboxRouteRoute
  AppPurchaseHistoryRouteRoute: typeof AppPurchaseHistoryRouteRoute
  AppQuestsRouteRoute: typeof AppQuestsRouteRouteWithChildren
  AppRedeemRouteRoute: typeof AppRedeemRouteRoute
  AppRedemptionHistoryRouteRoute: typeof AppRedemptionHistoryRouteRoute
  AppSearchRouteRoute: typeof AppSearchRouteRoute
  AppStoreRouteRoute: typeof AppStoreRouteRouteWithChildren
  AppCategoryIdRouteRoute: typeof AppCategoryIdRouteRoute
  AppGamePlayGameIdRouteRoute: typeof AppGamePlayGameIdRouteRoute
  AppYourPlayAccessControlsRouteRoute: typeof AppYourPlayAccessControlsRouteRouteWithChildren
  AppYourPlayActivityReminderRouteRoute: typeof AppYourPlayActivityReminderRouteRouteWithChildren
  AppYourPlayGameplayHistoryRouteRoute: typeof AppYourPlayGameplayHistoryRouteRoute
  AppYourPlayGameplayLimitsRouteRoute: typeof AppYourPlayGameplayLimitsRouteRouteWithChildren
  AppAccountVerificationFlowRoute: typeof AppAccountVerificationFlowRoute
  AppAccountVerificationTncRoute: typeof AppAccountVerificationTncRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppIndexRouteRoute: AppIndexRouteRoute,
  AppAccountLockedRouteRoute: AppAccountLockedRouteRouteWithChildren,
  AppAccountVerificationRouteRoute: AppAccountVerificationRouteRoute,
  AppActivityLogRouteRoute: AppActivityLogRouteRoute,
  AppInboxRouteRoute: AppInboxRouteRoute,
  AppPurchaseHistoryRouteRoute: AppPurchaseHistoryRouteRoute,
  AppQuestsRouteRoute: AppQuestsRouteRouteWithChildren,
  AppRedeemRouteRoute: AppRedeemRouteRoute,
  AppRedemptionHistoryRouteRoute: AppRedemptionHistoryRouteRoute,
  AppSearchRouteRoute: AppSearchRouteRoute,
  AppStoreRouteRoute: AppStoreRouteRouteWithChildren,
  AppCategoryIdRouteRoute: AppCategoryIdRouteRoute,
  AppGamePlayGameIdRouteRoute: AppGamePlayGameIdRouteRoute,
  AppYourPlayAccessControlsRouteRoute:
    AppYourPlayAccessControlsRouteRouteWithChildren,
  AppYourPlayActivityReminderRouteRoute:
    AppYourPlayActivityReminderRouteRouteWithChildren,
  AppYourPlayGameplayHistoryRouteRoute: AppYourPlayGameplayHistoryRouteRoute,
  AppYourPlayGameplayLimitsRouteRoute:
    AppYourPlayGameplayLimitsRouteRouteWithChildren,
  AppAccountVerificationFlowRoute: AppAccountVerificationFlowRoute,
  AppAccountVerificationTncRoute: AppAccountVerificationTncRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AppRouteRouteWithChildren
  '/auth-server-unavailable': typeof AuthServerUnavailableRouteRoute
  '/self-exclusion-confirmation': typeof SelfExclusionConfirmationRouteRoute
  '/take-a-break-confirmation': typeof TakeABreakConfirmationRouteRoute
  '/geo-block': typeof GeoBlockRoute
  '/inactivity-logout': typeof InactivityLogoutRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/postal-request-code': typeof PostalRequestCodeRoute
  '/register': typeof RegisterRoute
  '/': typeof AppIndexRouteRoute
  '/account-locked': typeof AppAccountLockedRouteRouteWithChildren
  '/account-verification': typeof AppAccountVerificationRouteRoute
  '/activity-log': typeof AppActivityLogRouteRoute
  '/inbox': typeof AppInboxRouteRoute
  '/purchase-history': typeof AppPurchaseHistoryRouteRoute
  '/quests': typeof AppQuestsRouteRouteWithChildren
  '/redeem': typeof AppRedeemRouteRoute
  '/redemption-history': typeof AppRedemptionHistoryRouteRoute
  '/search': typeof AppSearchRouteRoute
  '/store': typeof AppStoreRouteRouteWithChildren
  '/category/$id': typeof AppCategoryIdRouteRoute
  '/game-play/$gameId': typeof AppGamePlayGameIdRouteRoute
  '/your-play/access-controls': typeof AppYourPlayAccessControlsRouteRouteWithChildren
  '/your-play/activity-reminder': typeof AppYourPlayActivityReminderRouteRouteWithChildren
  '/your-play/gameplay-history': typeof AppYourPlayGameplayHistoryRouteRoute
  '/your-play/gameplay-limits': typeof AppYourPlayGameplayLimitsRouteRouteWithChildren
  '/account-locked/error': typeof AppAccountLockedErrorRoute
  '/account-locked/restricted-jurisdiction': typeof AppAccountLockedRestrictedJurisdictionRoute
  '/account-locked/self-exclusion': typeof AppAccountLockedSelfExclusionRoute
  '/account-locked/take-a-break': typeof AppAccountLockedTakeABreakRoute
  '/account-locked/under-age': typeof AppAccountLockedUnderAgeRoute
  '/account-locked/verification-required': typeof AppAccountLockedVerificationRequiredRoute
  '/account-verification/flow': typeof AppAccountVerificationFlowRoute
  '/account-verification/tnc': typeof AppAccountVerificationTncRoute
  '/quests/active-quests': typeof AppQuestsActiveQuestsRoute
  '/quests/quests-history': typeof AppQuestsQuestsHistoryRoute
  '/store/buy-gold-coins': typeof AppStoreBuyGoldCoinsRouteWithChildren
  '/store/play-for-free': typeof AppStorePlayForFreeRoute
  '/your-play/activity-reminder/': typeof AppYourPlayActivityReminderIndexRouteRoute
  '/your-play/access-controls/all': typeof AppYourPlayAccessControlsAllRouteRoute
  '/your-play/access-controls/self-exclusion': typeof AppYourPlayAccessControlsSelfExclusionRouteRoute
  '/your-play/access-controls/take-a-break': typeof AppYourPlayAccessControlsTakeABreakRouteRoute
  '/your-play/activity-reminder/set-reminder': typeof AppYourPlayActivityReminderSetReminderRouteRoute
  '/your-play/gameplay-limits/add': typeof AppYourPlayGameplayLimitsAddRouteRoute
  '/your-play/gameplay-limits/all': typeof AppYourPlayGameplayLimitsAllRouteRoute
  '/store/buy-gold-coins/$id': typeof AppStoreBuyGoldCoinsIdRoute
  '/your-play/gameplay-limits/manage/$type': typeof AppYourPlayGameplayLimitsManageTypeRouteRoute
}

export interface FileRoutesByTo {
  '/auth-server-unavailable': typeof AuthServerUnavailableRouteRoute
  '/self-exclusion-confirmation': typeof SelfExclusionConfirmationRouteRoute
  '/take-a-break-confirmation': typeof TakeABreakConfirmationRouteRoute
  '/geo-block': typeof GeoBlockRoute
  '/inactivity-logout': typeof InactivityLogoutRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/postal-request-code': typeof PostalRequestCodeRoute
  '/register': typeof RegisterRoute
  '/': typeof AppIndexRouteRoute
  '/account-locked': typeof AppAccountLockedRouteRouteWithChildren
  '/account-verification': typeof AppAccountVerificationRouteRoute
  '/activity-log': typeof AppActivityLogRouteRoute
  '/inbox': typeof AppInboxRouteRoute
  '/purchase-history': typeof AppPurchaseHistoryRouteRoute
  '/quests': typeof AppQuestsRouteRouteWithChildren
  '/redeem': typeof AppRedeemRouteRoute
  '/redemption-history': typeof AppRedemptionHistoryRouteRoute
  '/search': typeof AppSearchRouteRoute
  '/store': typeof AppStoreRouteRouteWithChildren
  '/category/$id': typeof AppCategoryIdRouteRoute
  '/game-play/$gameId': typeof AppGamePlayGameIdRouteRoute
  '/your-play/access-controls': typeof AppYourPlayAccessControlsRouteRouteWithChildren
  '/your-play/gameplay-history': typeof AppYourPlayGameplayHistoryRouteRoute
  '/your-play/gameplay-limits': typeof AppYourPlayGameplayLimitsRouteRouteWithChildren
  '/account-locked/error': typeof AppAccountLockedErrorRoute
  '/account-locked/restricted-jurisdiction': typeof AppAccountLockedRestrictedJurisdictionRoute
  '/account-locked/self-exclusion': typeof AppAccountLockedSelfExclusionRoute
  '/account-locked/take-a-break': typeof AppAccountLockedTakeABreakRoute
  '/account-locked/under-age': typeof AppAccountLockedUnderAgeRoute
  '/account-locked/verification-required': typeof AppAccountLockedVerificationRequiredRoute
  '/account-verification/flow': typeof AppAccountVerificationFlowRoute
  '/account-verification/tnc': typeof AppAccountVerificationTncRoute
  '/quests/active-quests': typeof AppQuestsActiveQuestsRoute
  '/quests/quests-history': typeof AppQuestsQuestsHistoryRoute
  '/store/buy-gold-coins': typeof AppStoreBuyGoldCoinsRouteWithChildren
  '/store/play-for-free': typeof AppStorePlayForFreeRoute
  '/your-play/activity-reminder': typeof AppYourPlayActivityReminderIndexRouteRoute
  '/your-play/access-controls/all': typeof AppYourPlayAccessControlsAllRouteRoute
  '/your-play/access-controls/self-exclusion': typeof AppYourPlayAccessControlsSelfExclusionRouteRoute
  '/your-play/access-controls/take-a-break': typeof AppYourPlayAccessControlsTakeABreakRouteRoute
  '/your-play/activity-reminder/set-reminder': typeof AppYourPlayActivityReminderSetReminderRouteRoute
  '/your-play/gameplay-limits/add': typeof AppYourPlayGameplayLimitsAddRouteRoute
  '/your-play/gameplay-limits/all': typeof AppYourPlayGameplayLimitsAllRouteRoute
  '/store/buy-gold-coins/$id': typeof AppStoreBuyGoldCoinsIdRoute
  '/your-play/gameplay-limits/manage/$type': typeof AppYourPlayGameplayLimitsManageTypeRouteRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/auth-server-unavailable': typeof AuthServerUnavailableRouteRoute
  '/self-exclusion-confirmation': typeof SelfExclusionConfirmationRouteRoute
  '/take-a-break-confirmation': typeof TakeABreakConfirmationRouteRoute
  '/geo-block': typeof GeoBlockRoute
  '/inactivity-logout': typeof InactivityLogoutRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/postal-request-code': typeof PostalRequestCodeRoute
  '/register': typeof RegisterRoute
  '/_app/': typeof AppIndexRouteRoute
  '/_app/account-locked': typeof AppAccountLockedRouteRouteWithChildren
  '/_app/account-verification': typeof AppAccountVerificationRouteRoute
  '/_app/activity-log': typeof AppActivityLogRouteRoute
  '/_app/inbox': typeof AppInboxRouteRoute
  '/_app/purchase-history': typeof AppPurchaseHistoryRouteRoute
  '/_app/quests': typeof AppQuestsRouteRouteWithChildren
  '/_app/redeem': typeof AppRedeemRouteRoute
  '/_app/redemption-history': typeof AppRedemptionHistoryRouteRoute
  '/_app/search': typeof AppSearchRouteRoute
  '/_app/store': typeof AppStoreRouteRouteWithChildren
  '/_app/category/$id': typeof AppCategoryIdRouteRoute
  '/_app/game-play/$gameId': typeof AppGamePlayGameIdRouteRoute
  '/_app/your-play/access-controls': typeof AppYourPlayAccessControlsRouteRouteWithChildren
  '/_app/your-play/activity-reminder': typeof AppYourPlayActivityReminderRouteRouteWithChildren
  '/_app/your-play/gameplay-history': typeof AppYourPlayGameplayHistoryRouteRoute
  '/_app/your-play/gameplay-limits': typeof AppYourPlayGameplayLimitsRouteRouteWithChildren
  '/_app/account-locked/error': typeof AppAccountLockedErrorRoute
  '/_app/account-locked/restricted-jurisdiction': typeof AppAccountLockedRestrictedJurisdictionRoute
  '/_app/account-locked/self-exclusion': typeof AppAccountLockedSelfExclusionRoute
  '/_app/account-locked/take-a-break': typeof AppAccountLockedTakeABreakRoute
  '/_app/account-locked/under-age': typeof AppAccountLockedUnderAgeRoute
  '/_app/account-locked/verification-required': typeof AppAccountLockedVerificationRequiredRoute
  '/_app/account-verification_/flow': typeof AppAccountVerificationFlowRoute
  '/_app/account-verification_/tnc': typeof AppAccountVerificationTncRoute
  '/_app/quests/active-quests': typeof AppQuestsActiveQuestsRoute
  '/_app/quests/quests-history': typeof AppQuestsQuestsHistoryRoute
  '/_app/store/buy-gold-coins': typeof AppStoreBuyGoldCoinsRouteWithChildren
  '/_app/store/play-for-free': typeof AppStorePlayForFreeRoute
  '/_app/your-play/activity-reminder/': typeof AppYourPlayActivityReminderIndexRouteRoute
  '/_app/your-play/access-controls/all': typeof AppYourPlayAccessControlsAllRouteRoute
  '/_app/your-play/access-controls/self-exclusion': typeof AppYourPlayAccessControlsSelfExclusionRouteRoute
  '/_app/your-play/access-controls/take-a-break': typeof AppYourPlayAccessControlsTakeABreakRouteRoute
  '/_app/your-play/activity-reminder/set-reminder': typeof AppYourPlayActivityReminderSetReminderRouteRoute
  '/_app/your-play/gameplay-limits/add': typeof AppYourPlayGameplayLimitsAddRouteRoute
  '/_app/your-play/gameplay-limits/all': typeof AppYourPlayGameplayLimitsAllRouteRoute
  '/_app/store/buy-gold-coins/$id': typeof AppStoreBuyGoldCoinsIdRoute
  '/_app/your-play/gameplay-limits/manage/$type': typeof AppYourPlayGameplayLimitsManageTypeRouteRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/auth-server-unavailable'
    | '/self-exclusion-confirmation'
    | '/take-a-break-confirmation'
    | '/geo-block'
    | '/inactivity-logout'
    | '/login'
    | '/logout'
    | '/postal-request-code'
    | '/register'
    | '/'
    | '/account-locked'
    | '/account-verification'
    | '/activity-log'
    | '/inbox'
    | '/purchase-history'
    | '/quests'
    | '/redeem'
    | '/redemption-history'
    | '/search'
    | '/store'
    | '/category/$id'
    | '/game-play/$gameId'
    | '/your-play/access-controls'
    | '/your-play/activity-reminder'
    | '/your-play/gameplay-history'
    | '/your-play/gameplay-limits'
    | '/account-locked/error'
    | '/account-locked/restricted-jurisdiction'
    | '/account-locked/self-exclusion'
    | '/account-locked/take-a-break'
    | '/account-locked/under-age'
    | '/account-locked/verification-required'
    | '/account-verification/flow'
    | '/account-verification/tnc'
    | '/quests/active-quests'
    | '/quests/quests-history'
    | '/store/buy-gold-coins'
    | '/store/play-for-free'
    | '/your-play/activity-reminder/'
    | '/your-play/access-controls/all'
    | '/your-play/access-controls/self-exclusion'
    | '/your-play/access-controls/take-a-break'
    | '/your-play/activity-reminder/set-reminder'
    | '/your-play/gameplay-limits/add'
    | '/your-play/gameplay-limits/all'
    | '/store/buy-gold-coins/$id'
    | '/your-play/gameplay-limits/manage/$type'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth-server-unavailable'
    | '/self-exclusion-confirmation'
    | '/take-a-break-confirmation'
    | '/geo-block'
    | '/inactivity-logout'
    | '/login'
    | '/logout'
    | '/postal-request-code'
    | '/register'
    | '/'
    | '/account-locked'
    | '/account-verification'
    | '/activity-log'
    | '/inbox'
    | '/purchase-history'
    | '/quests'
    | '/redeem'
    | '/redemption-history'
    | '/search'
    | '/store'
    | '/category/$id'
    | '/game-play/$gameId'
    | '/your-play/access-controls'
    | '/your-play/gameplay-history'
    | '/your-play/gameplay-limits'
    | '/account-locked/error'
    | '/account-locked/restricted-jurisdiction'
    | '/account-locked/self-exclusion'
    | '/account-locked/take-a-break'
    | '/account-locked/under-age'
    | '/account-locked/verification-required'
    | '/account-verification/flow'
    | '/account-verification/tnc'
    | '/quests/active-quests'
    | '/quests/quests-history'
    | '/store/buy-gold-coins'
    | '/store/play-for-free'
    | '/your-play/activity-reminder'
    | '/your-play/access-controls/all'
    | '/your-play/access-controls/self-exclusion'
    | '/your-play/access-controls/take-a-break'
    | '/your-play/activity-reminder/set-reminder'
    | '/your-play/gameplay-limits/add'
    | '/your-play/gameplay-limits/all'
    | '/store/buy-gold-coins/$id'
    | '/your-play/gameplay-limits/manage/$type'
  id:
    | '__root__'
    | '/_app'
    | '/auth-server-unavailable'
    | '/self-exclusion-confirmation'
    | '/take-a-break-confirmation'
    | '/geo-block'
    | '/inactivity-logout'
    | '/login'
    | '/logout'
    | '/postal-request-code'
    | '/register'
    | '/_app/'
    | '/_app/account-locked'
    | '/_app/account-verification'
    | '/_app/activity-log'
    | '/_app/inbox'
    | '/_app/purchase-history'
    | '/_app/quests'
    | '/_app/redeem'
    | '/_app/redemption-history'
    | '/_app/search'
    | '/_app/store'
    | '/_app/category/$id'
    | '/_app/game-play/$gameId'
    | '/_app/your-play/access-controls'
    | '/_app/your-play/activity-reminder'
    | '/_app/your-play/gameplay-history'
    | '/_app/your-play/gameplay-limits'
    | '/_app/account-locked/error'
    | '/_app/account-locked/restricted-jurisdiction'
    | '/_app/account-locked/self-exclusion'
    | '/_app/account-locked/take-a-break'
    | '/_app/account-locked/under-age'
    | '/_app/account-locked/verification-required'
    | '/_app/account-verification_/flow'
    | '/_app/account-verification_/tnc'
    | '/_app/quests/active-quests'
    | '/_app/quests/quests-history'
    | '/_app/store/buy-gold-coins'
    | '/_app/store/play-for-free'
    | '/_app/your-play/activity-reminder/'
    | '/_app/your-play/access-controls/all'
    | '/_app/your-play/access-controls/self-exclusion'
    | '/_app/your-play/access-controls/take-a-break'
    | '/_app/your-play/activity-reminder/set-reminder'
    | '/_app/your-play/gameplay-limits/add'
    | '/_app/your-play/gameplay-limits/all'
    | '/_app/store/buy-gold-coins/$id'
    | '/_app/your-play/gameplay-limits/manage/$type'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthServerUnavailableRouteRoute: typeof AuthServerUnavailableRouteRoute
  SelfExclusionConfirmationRouteRoute: typeof SelfExclusionConfirmationRouteRoute
  TakeABreakConfirmationRouteRoute: typeof TakeABreakConfirmationRouteRoute
  GeoBlockRoute: typeof GeoBlockRoute
  InactivityLogoutRoute: typeof InactivityLogoutRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  PostalRequestCodeRoute: typeof PostalRequestCodeRoute
  RegisterRoute: typeof RegisterRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthServerUnavailableRouteRoute: AuthServerUnavailableRouteRoute,
  SelfExclusionConfirmationRouteRoute: SelfExclusionConfirmationRouteRoute,
  TakeABreakConfirmationRouteRoute: TakeABreakConfirmationRouteRoute,
  GeoBlockRoute: GeoBlockRoute,
  InactivityLogoutRoute: InactivityLogoutRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  PostalRequestCodeRoute: PostalRequestCodeRoute,
  RegisterRoute: RegisterRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/auth-server-unavailable",
        "/self-exclusion-confirmation",
        "/take-a-break-confirmation",
        "/geo-block",
        "/inactivity-logout",
        "/login",
        "/logout",
        "/postal-request-code",
        "/register"
      ]
    },
    "/_app": {
      "filePath": "_app/route.tsx",
      "children": [
        "/_app/",
        "/_app/account-locked",
        "/_app/account-verification",
        "/_app/activity-log",
        "/_app/inbox",
        "/_app/purchase-history",
        "/_app/quests",
        "/_app/redeem",
        "/_app/redemption-history",
        "/_app/search",
        "/_app/store",
        "/_app/category/$id",
        "/_app/game-play/$gameId",
        "/_app/your-play/access-controls",
        "/_app/your-play/activity-reminder",
        "/_app/your-play/gameplay-history",
        "/_app/your-play/gameplay-limits",
        "/_app/account-verification_/flow",
        "/_app/account-verification_/tnc"
      ]
    },
    "/auth-server-unavailable": {
      "filePath": "auth-server-unavailable/route.tsx"
    },
    "/self-exclusion-confirmation": {
      "filePath": "self-exclusion-confirmation/route.tsx"
    },
    "/take-a-break-confirmation": {
      "filePath": "take-a-break-confirmation/route.tsx"
    },
    "/geo-block": {
      "filePath": "geo-block.tsx"
    },
    "/inactivity-logout": {
      "filePath": "inactivity-logout.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/postal-request-code": {
      "filePath": "postal-request-code.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/_app/": {
      "filePath": "_app/index/route.tsx",
      "parent": "/_app"
    },
    "/_app/account-locked": {
      "filePath": "_app/account-locked/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/account-locked/error",
        "/_app/account-locked/restricted-jurisdiction",
        "/_app/account-locked/self-exclusion",
        "/_app/account-locked/take-a-break",
        "/_app/account-locked/under-age",
        "/_app/account-locked/verification-required"
      ]
    },
    "/_app/account-verification": {
      "filePath": "_app/account-verification/route.tsx",
      "parent": "/_app"
    },
    "/_app/activity-log": {
      "filePath": "_app/activity-log/route.tsx",
      "parent": "/_app"
    },
    "/_app/inbox": {
      "filePath": "_app/inbox/route.tsx",
      "parent": "/_app"
    },
    "/_app/purchase-history": {
      "filePath": "_app/purchase-history/route.tsx",
      "parent": "/_app"
    },
    "/_app/quests": {
      "filePath": "_app/quests/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/quests/active-quests",
        "/_app/quests/quests-history"
      ]
    },
    "/_app/redeem": {
      "filePath": "_app/redeem/route.tsx",
      "parent": "/_app"
    },
    "/_app/redemption-history": {
      "filePath": "_app/redemption-history/route.tsx",
      "parent": "/_app"
    },
    "/_app/search": {
      "filePath": "_app/search/route.tsx",
      "parent": "/_app"
    },
    "/_app/store": {
      "filePath": "_app/store/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/store/buy-gold-coins",
        "/_app/store/play-for-free"
      ]
    },
    "/_app/category/$id": {
      "filePath": "_app/category.$id/route.tsx",
      "parent": "/_app"
    },
    "/_app/game-play/$gameId": {
      "filePath": "_app/game-play.$gameId/route.tsx",
      "parent": "/_app"
    },
    "/_app/your-play/access-controls": {
      "filePath": "_app/your-play.access-controls/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/your-play/access-controls/all",
        "/_app/your-play/access-controls/self-exclusion",
        "/_app/your-play/access-controls/take-a-break"
      ]
    },
    "/_app/your-play/activity-reminder": {
      "filePath": "_app/your-play.activity-reminder/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/your-play/activity-reminder/",
        "/_app/your-play/activity-reminder/set-reminder"
      ]
    },
    "/_app/your-play/gameplay-history": {
      "filePath": "_app/your-play.gameplay-history/route.tsx",
      "parent": "/_app"
    },
    "/_app/your-play/gameplay-limits": {
      "filePath": "_app/your-play.gameplay-limits/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/your-play/gameplay-limits/add",
        "/_app/your-play/gameplay-limits/all",
        "/_app/your-play/gameplay-limits/manage/$type"
      ]
    },
    "/_app/account-locked/error": {
      "filePath": "_app/account-locked/error.tsx",
      "parent": "/_app/account-locked"
    },
    "/_app/account-locked/restricted-jurisdiction": {
      "filePath": "_app/account-locked/restricted-jurisdiction.tsx",
      "parent": "/_app/account-locked"
    },
    "/_app/account-locked/self-exclusion": {
      "filePath": "_app/account-locked/self-exclusion.tsx",
      "parent": "/_app/account-locked"
    },
    "/_app/account-locked/take-a-break": {
      "filePath": "_app/account-locked/take-a-break.tsx",
      "parent": "/_app/account-locked"
    },
    "/_app/account-locked/under-age": {
      "filePath": "_app/account-locked/under-age.tsx",
      "parent": "/_app/account-locked"
    },
    "/_app/account-locked/verification-required": {
      "filePath": "_app/account-locked/verification-required.tsx",
      "parent": "/_app/account-locked"
    },
    "/_app/account-verification_/flow": {
      "filePath": "_app/account-verification_/flow.tsx",
      "parent": "/_app"
    },
    "/_app/account-verification_/tnc": {
      "filePath": "_app/account-verification_/tnc.tsx",
      "parent": "/_app"
    },
    "/_app/quests/active-quests": {
      "filePath": "_app/quests/active-quests.tsx",
      "parent": "/_app/quests"
    },
    "/_app/quests/quests-history": {
      "filePath": "_app/quests/quests-history.tsx",
      "parent": "/_app/quests"
    },
    "/_app/store/buy-gold-coins": {
      "filePath": "_app/store/buy-gold-coins.tsx",
      "parent": "/_app/store",
      "children": [
        "/_app/store/buy-gold-coins/$id"
      ]
    },
    "/_app/store/play-for-free": {
      "filePath": "_app/store/play-for-free.tsx",
      "parent": "/_app/store"
    },
    "/_app/your-play/activity-reminder/": {
      "filePath": "_app/your-play.activity-reminder/index/route.tsx",
      "parent": "/_app/your-play/activity-reminder"
    },
    "/_app/your-play/access-controls/all": {
      "filePath": "_app/your-play.access-controls/all/route.tsx",
      "parent": "/_app/your-play/access-controls"
    },
    "/_app/your-play/access-controls/self-exclusion": {
      "filePath": "_app/your-play.access-controls/self-exclusion/route.tsx",
      "parent": "/_app/your-play/access-controls"
    },
    "/_app/your-play/access-controls/take-a-break": {
      "filePath": "_app/your-play.access-controls/take-a-break/route.tsx",
      "parent": "/_app/your-play/access-controls"
    },
    "/_app/your-play/activity-reminder/set-reminder": {
      "filePath": "_app/your-play.activity-reminder/set-reminder/route.tsx",
      "parent": "/_app/your-play/activity-reminder"
    },
    "/_app/your-play/gameplay-limits/add": {
      "filePath": "_app/your-play.gameplay-limits/add/route.tsx",
      "parent": "/_app/your-play/gameplay-limits"
    },
    "/_app/your-play/gameplay-limits/all": {
      "filePath": "_app/your-play.gameplay-limits/all/route.tsx",
      "parent": "/_app/your-play/gameplay-limits"
    },
    "/_app/store/buy-gold-coins/$id": {
      "filePath": "_app/store/buy-gold-coins.$id.tsx",
      "parent": "/_app/store/buy-gold-coins"
    },
    "/_app/your-play/gameplay-limits/manage/$type": {
      "filePath": "_app/your-play.gameplay-limits/manage.$type/route.tsx",
      "parent": "/_app/your-play/gameplay-limits"
    }
  }
}
ROUTE_MANIFEST_END */
